import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputCard } from '@components/cards';
import { RADIO, VARIANT_L } from '@components/cards/input-card/input-card.type';
import { IconOfflineSale } from '@components/icons/icon-offline-sale';
import { IconPass } from '@components/icons/icon-pass';
import { IconTicket } from '@components/icons/icon-ticket';
import { ModalFooter } from '@components/modals/modal-footer';
import { ModalHeader } from '@components/modals/modal-header';
import {
  OFFLINE_SALES_SCOPE_EVENT,
  OFFLINE_SALES_SCOPE_PASS,
  OfflineSalesForm,
  OfflineSalesScope,
} from '@components/process-offline-sales/process-offline-sales.type';

import { ScopeCardContent } from './components/scope-card-content';

export const SelectScope = ({ onContinue }: { onContinue: () => void }) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<OfflineSalesForm>();
  const scope = watch('scope');

  const toggleScope = (next: OfflineSalesScope) => {
    if (scope === next) return;
    setValue('scope', next, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
    if (next === OFFLINE_SALES_SCOPE_PASS) {
      setValue('eventId', '');
      setValue('offerId', '');
      setValue('saleType', '');
    } else {
      setValue('passId', '');
    }
  };

  return (
    <>
      <ModalHeader title={t('offers:offlineSalesTitle')} primaryIcon={IconOfflineSale} />
      <div className='flex flex-col gap-4 px-4 py-6 sm:px-20 sm:pb-12'>
        <p className='text-body-m text-secondary'>{t('offers:offlineSalesScopeStepDescription')}</p>
        <div className='flex flex-col gap-3'>
          <InputCard
            type={RADIO}
            variant={VARIANT_L}
            isChecked={scope === OFFLINE_SALES_SCOPE_EVENT}
            isDisabled={false}
            handleClick={() => toggleScope(OFFLINE_SALES_SCOPE_EVENT)}>
            <ScopeCardContent
              icon={IconTicket}
              title={t('offers:offlineSalesScopeEventTitle')}
              subtitle={t('offers:offlineSalesScopeEventSubtitle')}
            />
          </InputCard>
          <InputCard
            type={RADIO}
            variant={VARIANT_L}
            isChecked={scope === OFFLINE_SALES_SCOPE_PASS}
            isDisabled={false}
            handleClick={() => toggleScope(OFFLINE_SALES_SCOPE_PASS)}>
            <ScopeCardContent
              icon={IconPass}
              title={t('offers:offlineSalesScopePassTitle')}
              subtitle={t('offers:offlineSalesScopePassSubtitle')}
            />
          </InputCard>
        </div>
      </div>
      <ModalFooter
        primaryButtonText={t('offers:continueButton')}
        onPrimaryClick={onContinue}
        isPrimaryDisabled={!scope}
      />
    </>
  );
};
